<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="img"><a id="page5"><img alt="image" src="images/p5.jpg"/></a></p><a id="page5">
<p class="pagebreak"></p>
</a><p class="CHO-Title"><a id="page5"></a><a id="page4"><span class="col1">Contents</span></a></p><a id="page4">
</a><p class="toc"><a id="page4"></a><a href="#/cap01"><span class="col1">Thanksgiving Traditions</span></a></p>
<p class="toc"><a href="#/cap02"><span class="col1">Starters</span></a></p>
<p class="toc"><span href="#/cap03" title="Link target outside of Sample"><span class="col1">Main Dishes</span></span></p>
<p class="toc"><span href="#/cap04" title="Link target outside of Sample"><span class="col1">Vegetables &amp; Fruits</span></span></p>
<p class="toc"><span href="#/cap05" title="Link target outside of Sample"><span class="col1">Potatoes &amp; Stuffings</span></span></p>
<p class="toc"><span href="#/cap06" title="Link target outside of Sample"><span class="col1">Desserts</span></span></p>
<p class="toc"><span href="#/cap07" title="Link target outside of Sample"><span class="col1">Menu Inspirations</span></span></p>
<p class="toc"><span href="#/cap08" title="Link target outside of Sample"><span class="col1">Ideas for Leftovers</span></span></p>
<p class="toc"><span href="#/cap09" title="Link target outside of Sample"><span class="col1">Turkey Know-How</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?1d82f8d2